import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class BlacksmithBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.BLACKSMITH;
}

export default BlacksmithBuildingTileEntity;
